<template>
  <div>
    <PCNavbar selectIndex="5"/>
    <MobileNavBar :currentActive="4" />
    <Infogw/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Infogw from '@/components/infogw/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Infogw
  },
}
</script>

<style>
</style>